import { combinedFeatureFlagsSelector } from '@mm/state/selectors/featureFlagsSelectors';
import classnames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import './GreenMarker.pcss';

type Props = {
  className?: string;
};

export const GreenMarker = ({ className }: Props) => {
  const classList = classnames('green-marker', className);

  const showActivationCues = useSelector(
    combinedFeatureFlagsSelector,
  ).show_cues;

  return showActivationCues ? <div className={classList} /> : null;
};
